// extracted by mini-css-extract-plugin
export default {"categoriesSelectPopup":"styled_categoriesSelectPopup__6dY1L"};